<template>
  <div class="wrap">
    <div class="header-wrap" :style="{ backgroundImage: `url(${headerImg})` }">
      <div class="card-message">
        <div>有效期：{{ cardExpiryDate }}</div>
        <div>(有效期为{{ cardTime }}天)</div>
      </div>
    </div>
    <BenefitList />
    <div class="footer">
      <div class="footer-content">
        <div class="order" @click="handleToOrder">
          <svg-icon iconClass="bj-service-hz" class="svg-icon" />我的订单
        </div>
        <div class="line"></div>
        <div class="service" @click="handleToService">
          <svg-icon iconClass="bj-order-hz" class="svg-icon" />客服中心
        </div>
      </div>
      <div class="service-time">
        <p>
          客服电话：
          <a href="tel:400-150-9669">400-150-9669</a
          ><span>(每日7:00-21:00)</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, watch } from "@vue/composition-api";
import dayjs from "dayjs";

import { useRouter, useStore } from "@/components/use/base";

import BenefitList from "../component/benefitList.vue";

export default defineComponent({
  components: {
    BenefitList,
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );
    const isLogin = computed(() => !!store.state.token);
    const isMember = computed(() => store.state.isMember);
    const userInfo = computed(() => store.state.userInfo);
    const headerImg = computed(() => {
      return {
        xxn001:
          "https://common-h5-dev.xiangshuheika.com/static/upload/202604029fb5cc6ed2c63.png",
        xxn002:
          "https://common-h5-dev.xiangshuheika.com/static/upload/20260402df4269ceb939f.png",
        xxn003:
          "https://common-h5-dev.xiangshuheika.com/static/upload/20260402df4269ceb939f.png",
      }[store.state.namespace];
    });

    const cardExpiryDate = computed(() =>
      dayjs(userInfo.value.card_expiry_date?.[0]).format("YYYY.MM.DD")
    );

    const cardTime = computed(() => {
      const start = dayjs(userInfo.value.t_vip_created);
      const end = dayjs(userInfo.value.card_expiry_date?.[0]);
      return end.diff(start, "day") + 1;
    });

    watch(
      () => [isMember.value, isLogin.value],
      ([newVal, isLogin]) => {
        if (!newVal || !isLogin) {
          router.replace(
            `/commonLogin?namespace_group=${namespaceGroup.value}`
          );
        }
      },
      { deep: true, immediate: true }
    );

    const handleToOrder = () => {
      router.push("/order");
    };

    const handleToService = () => {
      router.push("/service");
    };

    return {
      handleToOrder,
      handleToService,
      cardExpiryDate,
      cardTime,
      headerImg,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  min-height: 100vh;
  background-color: #fff;

  .header-wrap {
    width: 375px;
    height: 168px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;

    .card-message {
      position: absolute;
      left: 29px;
      top: 101px;
      font-weight: 400;
      font-size: 9px;
      color: #b8aba4;
      line-height: 13px;
    }
  }
}

.footer {
  margin-top: auto;
  padding: 20px 12px;
  .footer-content {
    height: 32px;
    background: #f8f8f8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
  }
  .svg-icon {
    font-size: 20px;
    margin-right: 9px;
  }

  .order {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .line {
    width: 1px;
    height: 23px;
    background: #e4e4e4;
  }

  .service {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .service-time {
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 14px;
    text-align: center;
    margin-top: 12px;
    a {
      color: #0170fe;
    }
    p {
      span {
        margin-left: 8px;
        color: #666666;
      }
    }
  }
}
</style>
